import { render, staticRenderFns } from "./FormSelect.vue?vue&type=template&id=70bd1bfa&"
import script from "./FormSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports